"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Tag_1 = require("./_Tag");
var _ReplicationRuleAndOperator_1 = require("./_ReplicationRuleAndOperator");
exports._ReplicationRuleFilter = {
    type: "structure",
    required: [],
    members: {
        Prefix: {
            shape: {
                type: "string"
            }
        },
        Tag: {
            shape: _Tag_1._Tag
        },
        And: {
            shape: _ReplicationRuleAndOperator_1._ReplicationRuleAndOperator
        }
    }
};
//# sourceMappingURL=_ReplicationRuleFilter.js.map